<template>
  <div>
    <div class="row">
      <div class="col-md-4 mb-4">
        <info-card
          :title="'Valor do estoque (Preço de Venda)'"
          icon="fa-boxes"
          variant="success"
          :value="sumStockValue.sumStockValue"
        />
      </div>
      <!-- <div class="col-md-4 mb-4">
        <info-card
          :title="'Vendas do mês'"
          icon="fa-shopping-cart"
          variant="primary"
          :value="monthOrderTotal.sum_net_total"
        />
      </div>
      <div class="col-md-4 mb-4">
        <info-card
          :title="'Total contas a receber'"
          icon="fa-file-invoice-dollar"
          variant="success"
          :value="openBillReceivebleTotal.sum_due_value"
        />
      </div>-->
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <span class="text-muted">Valor de estoque por categoria</span>
            <hr />
            <div class="row mb-4" v-for="(row, index) in sumStockValueByCategory" :key="index">
              <div class="col-6">
                <span v-if="row.category_description == null">Produtos sem categoria</span>
                <span v-else>{{ row.category_description }}</span>
              </div>
              <div class="col-6 text-right">
                {{ row.sumStockValue | decimal}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <error-handler :error="error" />
  </div>
</template>

<script>
import TablePaginator from "./../sections/TablePaginator.vue";
import InfoCard from "./../sections/dashboard/InfoCard.vue";
import AppBarChart from "./../ui/AppBarChart.vue";
import OrderHistoricChart from "./../charts/OrderHistoricChart.vue";
import Filter from "./../../mixins/Filters"

export default {
  components: {
    InfoCard,
    AppBarChart,
    OrderHistoricChart
  },

  data: function() {
    return {
      sumStockValue : 0,
      
      sumStockValueByCategory : {},

      error: null,
    };
  },

  created() {
    axios
      .post("api/dashboard/product/select", this.searchForm)
      .then(response => {
        this.sumStockValue = response.data.sumStockValue
        this.sumStockValueByCategory = response.data.sumStockValueByCategory
        //this.$store.commit("pageHasLoaded");
      })
      .catch(error => {
        this.error = error;
        this.$store.commit("pageHasLoadedWithError", { error: error });
      });
  },

  computed: {
    // accountTransactionSeries() {
    //   let series = []
    //   let labels = []
    //   series[0] = {}
    //   series[0].name = 'Entradas'
    //   series[0].data = this.accountTransactionsIn.map( elem => elem.sum_value)
    //   series[1] = {}
    //   series[1].name = 'Saidas'
    //   series[1].data = this.accountTransactionsOut.map( elem => elem.sum_value * -1)
    //   return series
    // },
    // accountTransactionLabels() {
    //   let labelsIn = this.accountTransactionsOut.map( elem => elem.paid_at)
    //   return labelsIn
    // },
  },

  methods: {}
};
</script>

<style>
</style>